// extracted by mini-css-extract-plugin
export default {"wrapper":"BlogInfoPage_wrapper__FFeY7"};